import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import { setTimestamp } from '../store/ui/uiActions';
import { receivedGraphState, receivedTimeline, gotApiError } from '../store/api/actions';
import { fetchStateByTimestamp, postTimelineSearchMetrics } from '../store/api';
import { getOverlappingObservationsByDates } from '../features/Scrubber/utils';
import { DEFAULT_TIMELINE_WINDOW } from '../constants';

const useNavigateToTimestamp = () => {
  const dispatch = useDispatch();
  const sessionId = useSelector((state) => state.api.sessionId);
  const uiRewindTimeline = useSelector((state) => state.ui.uiRewindTimeline);
  const _TIMELINE_WINDOW = useSelector((state) => state.api.flags.TIMELINE_WINDOW);
  const TIMELINE_WINDOW = _TIMELINE_WINDOW || DEFAULT_TIMELINE_WINDOW;
  const callIdRef = useRef(0);

  const navigateToTimestamp = useCallback(async (isoTimestamp, metricsAction) => {
    const callId = ++callIdRef.current;

    dispatch(setTimestamp(isoTimestamp));

    const { response, error } = await fetchStateByTimestamp({ timestamp: isoTimestamp });
    if (callIdRef.current !== callId) return;
    if (error) {
      dispatch(gotApiError({ message: error, title: 'State fetch failed' }));
      return;
    }

    dispatch(receivedGraphState(response));
    const end = DateTime.fromISO(isoTimestamp).toJSDate();
    const start = DateTime.fromISO(isoTimestamp).minus(TIMELINE_WINDOW).toJSDate();
    const filtered = getOverlappingObservationsByDates(uiRewindTimeline, start, end);
    dispatch(receivedTimeline(filtered));

    postTimelineSearchMetrics(sessionId, metricsAction, {
      from: DateTime.fromISO(isoTimestamp).minus(TIMELINE_WINDOW).toUTC().toISO(),
      to: DateTime.fromISO(isoTimestamp).toUTC().toISO(),
    });
  }, [dispatch, sessionId, uiRewindTimeline, TIMELINE_WINDOW]);

  return navigateToTimestamp;
};

export default useNavigateToTimestamp;
